export enum CurrencyPlacement {
  NO_CURRENCY = 0,
  BEFORE = 1,
  AFTER = 2,
}
